import React from "react"
import { MainPage } from "./pages/MainPage"
import { Link, Route, BrowserRouter as Router, Routes } from "react-router-dom"
//import parties from './data/parties.json';
import { useEffect, useState } from "react";
import { getAllCountries } from "./calculations/utilsV2";

export const ProvidersV2 = () => {
    const [selectedCountry, setSelectedCountry] = useState('All');
    //const pollsFunc = (country) => euPolitics.filter(x => x.country === country)[0]?.polls;
    //const pollsFunc = (country) => electionV2.Stats.find(x => x.Country === country).Polls;

    const allCountries = getAllCountries();
    const countryList = getAllCountries().map(x => x.Short).filter(x => x !== null && x !== undefined); //parties.map(x => x.short).filter(x => x && !["UK", "CY"].includes(x));
    //countryList.splice(0, 0, "EU");
    countryList.splice(0, 0, "All");
    const convertName = (short: string) => { 
        return allCountries.find(x => x.Short === short)?.Country;
        //return parties.find(x => x.short === short)?.country;
    }
    /*const getCount = (short: string) => {
        const count = getCookieCount(short, pollsFunc(convertName(short))?.slice(0, 10));
        if (count === 0) { return <></> }
        return <span className="bubble">{count}</span>
    }*/
    if (!['EU', 'All'].includes(selectedCountry) && selectedCountry) {
        const found = convertName(selectedCountry);
        if (found) {
            document.title = 'Polls and election statistics from ' + found + ' - Statostuff';
        } else {
            document.title = 'Statostuff';
        }
    } else {
        document.title = 'Statostuff';
    }

    return (<div>
            <Router>
                <div className="underline width180">
                    <img src={"/favicon.ico"} alt="Statostuff" height={14} /> &nbsp;
                    <b>Statostuff</b> &nbsp;
                    <span className="dot groupG" />&nbsp;
                    <span className="dot groupSD" />
                </div>

                <div>
                    <div className="wrap">
                        {countryList.map(x => (
                            <div key={x} className="headerCountry" onClick={() => setSelectedCountry(y => x ?? '')}>
                                <Link key={x} to={x ?? ''}>
                                    <span className={x === selectedCountry ? "selected" : "hoverable"}>
                                        <img src={"/flags/" + x?.toLowerCase() + ".png"} alt={x ?? ''} height={14} />
                                        &nbsp;{x}&nbsp;
                                    </span>
                                    {/*getCount(x)*/}
                                </Link>
                                |&nbsp;
                            </div>
                        ))}

                        <Routes>
                            {countryList.map(x => <Route key={x} path={x ?? ''} element={<SelectElement setSelectedCountry={setSelectedCountry} short={x ?? ''} />} />)}
                            {countryList.map(x => <Route key={x+"/result"} path={x+"/result"} element={<SelectElement setSelectedCountry={setSelectedCountry} short={x+"/result"} />} />)}
                            <Route path="/" element={<SelectElement setSelectedCountry={setSelectedCountry} short='All' />} />
                        </Routes>
                    </div>
                    <MainPage />
                </div>
            </Router>
        </div>)
}

interface SelectElementProps {
    short: string,
    setSelectedCountry: React.Dispatch<React.SetStateAction<string>>,
}

const SelectElement = (props: SelectElementProps) => {
    const { setSelectedCountry, short } = props;

    useEffect(() => {
        setSelectedCountry(x => short);
    }, [short]);

    return <div />
}